import React from "react";
import CompletedProject from "./image/completedProject.png";
import CreativeThinkers from "./image/creativeThinkers.png";
import AssociatedBrands from "./image/associatedBrands.png";
import "./ourImpact.css";

const OurImpact = () => {
  const gifData = [
    {
      id: 1,
      image: CompletedProject,
      text1: "100+",
      text2: "Completed Projects",
    },
    {
      id: 2,
      image: CreativeThinkers,
      text1: "20+",
      text2: "Creative Thinkers",
    },
    {
      id: 3,
      image: AssociatedBrands,
      text1: "40+",
      text2: "Associated Brands",
    },
  ];

  return (
    <div className="our-impact-content" id="our-impact">
      {/* Heading */}
      <h1 className="our-impact-heading">
        <span className="heading1">OUR</span>
        <span className="heading2">IMPACT</span>
      </h1>

      {/* Static Image Cards with Hover Scale */}
      <div className="gif-container">
        {gifData.map((card) => (
          <div key={card.id} className="gif-card">
            <div className="gif-image-container">
              <img
                src={card.image}
                alt={card.text2}
                className="gif-image scale-on-hover"
              />
            </div>
            <div className="gif-text">
              <div className="text1">{card.text1}</div>
              <div className="text2">{card.text2}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default OurImpact;

// import React, { useState } from "react";
// import CompletedProject from "./image/completedProject.png";
// import CreativeThinkers from "./image/creativeThinkers.png";
// import AssociatedBrands from "./image/associatedBrands.png";
// import Gif1 from "./image/gif1.gif";
// import RocketGif from "./image/Rocket.gif";
// import BulbGif from "./image/Bulb.gif";
// import BrandGif from "./image/Brand.gif";
// import "./ourImpact.css";

// const OurImpact = () => {
//   const [hoveredCard, setHoveredCard] = useState(null);

//   const gifData = [
//     {
//       id: 1,
//       image: CompletedProject,
//       gif: RocketGif,
//       text1: "100+",
//       text2: "Completed Projects",
//     },
//     {
//       id: 2,
//       image: CreativeThinkers,
//       gif: BulbGif,
//       text1: "20+",
//       text2: "Creative Thinkers",
//     },
//     {
//       id: 3,
//       image: AssociatedBrands,
//       gif: BrandGif,
//       text1: "40+",
//       text2: "Associated Brands",
//     },
//   ];

//   return (
//     <div className="our-impact-content" id="our-impact">
//       {/* Heading */}
//       <h1 className="our-impact-heading">
//         <span className="heading1">OUR</span>
//         <span className="heading2">IMPACT</span>
//       </h1>

//       {/* Dynamic Gif Container */}
//       <div className="gif-container">
//         {gifData.map((card) => (
//           <div
//             key={card.id}
//             className="gif-card"
//             onMouseEnter={() => setHoveredCard(card.id)}
//             onMouseLeave={() => setHoveredCard(null)}
//           >
//             <div
//               className="gif-image-container"
//               style={{
//                 backgroundImage: `url(${
//                   hoveredCard === card.id ? card.gif : card.image
//                 })`,
//               }}
//             ></div>
//             <div className="gif-text">
//               <div className="text1">{card.text1}</div>
//               <div className="text2">{card.text2}</div>
//             </div>
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// };

// export default OurImpact;
